import Image from 'gatsby-image';
import React from 'react';

import styles from './background.module.css';

export default ({ resolutions }) =>
  <Image className={styles.imageWrapper}
         outerWrapperClassName={styles.imageOuterWrapper}
         resolutions={resolutions} />
;

export const fragment = graphql`
  fragment BackgroundResolutions on ImageSharp {
    resolutions(
      width: 2560
      duotone: {
        highlight: "#999999"
        shadow: "#111111"
      }
    ) {
      ...GatsbyImageSharpResolutions
    }
  }
`;



// WEBPACK FOOTER //
// ./src/background/background.js